import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class HotelTax {
  static buildRequest(pHotelTaxObj,pHotelId,pTaxMode) {
    let returnValue = null;
    try {
      let body = pHotelTaxObj;


      if(body && pTaxMode)
      {   
            body.hotelId= pHotelId&& pHotelId.length?[...pHotelId]:null
        //     body.hotelCondition="SPECHOTEL"//temp

             body. paxType= []
            body.taxType=body.taxType?body.taxType.value:null
            body.taxCurrency=(body.taxCurrency&&body.taxMode==pTaxMode.FIXED )?body.taxCurrency.code:null

      }
      else
      {
        throw 'invalid req'
      }


      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.  API_HMS_COUNTRY_TAX ,
        "error in building body for create hotel tax",
        err.toString(),
        "buildRequest",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {
      returnValue = await HttpPost.makeHttpPostRequest(
        SERVICE_URL.API_HMS_COUNTRY_TAX,
        pReqOptions
      );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.  API_HMS_COUNTRY_TAX,
        "error in getting Response from  create hotel tax ",
        err.toString(),
        "getResponse",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }
}
